
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("33kwL", function(module, exports) {

$parcel$export(module.exports, "LegacyContentIcon", () => $a861837a9717b6e8$export$cba2ec8f585df2e0);

var $gwFzn = parcelRequire("gwFzn");

var $13WX1 = parcelRequire("13WX1");

var $5yCDo = parcelRequire("5yCDo");

var $hxQwS = parcelRequire("hxQwS");

var $bueVT = parcelRequire("bueVT");

var $1dIkM = parcelRequire("1dIkM");

var $8XnT0 = parcelRequire("8XnT0");

var $l79Tc = parcelRequire("l79Tc");

var $5qgLK = parcelRequire("5qgLK");

var $brDJd = parcelRequire("brDJd");

var $deok5 = parcelRequire("deok5");

var $hysuJ = parcelRequire("hysuJ");

var $gGVuu = parcelRequire("gGVuu");

var $b5erW = parcelRequire("b5erW");

var $6ilhH = parcelRequire("6ilhH");

var $kYaDH = parcelRequire("kYaDH");

var $l5uVy = parcelRequire("l5uVy");

var $zA80N = parcelRequire("zA80N");

var $l6Uai = parcelRequire("l6Uai");

var $9uooB = parcelRequire("9uooB");

var $c3Buv = parcelRequire("c3Buv");

var $1XIce = parcelRequire("1XIce");

var $8vuWl = parcelRequire("8vuWl");

var $56LwR = parcelRequire("56LwR");

var $aJZ9x = parcelRequire("aJZ9x");

var $aeG1X = parcelRequire("aeG1X");
const $a861837a9717b6e8$export$c647cb0ee6e282fe = [
    'small',
    'medium'
];
const $a861837a9717b6e8$var$typeNames = {
    page: 'page',
    livePage: 'livepage',
    blogpost: 'blogpost',
    whiteboard: 'whiteboard',
    database: 'database',
    embed: 'embed',
    calendar: 'com.atlassian.confluence.extra.team-calendars:calendar-content-type',
    calendarView: 'com.atlassian.confluence.extra.team-calendars:space-calendars-view-content-type',
    comment: 'comment',
    question: 'ac:com.atlassian.confluence.plugins.confluence-questions:question',
    space: 'space',
    folder: 'folder',
    smartLinkEmbed: 'smartLinkEmbed',
    import: 'import'
};
const $a861837a9717b6e8$export$b14ad400b1d09e0f = {
    [$a861837a9717b6e8$var$typeNames.page]: [
        (0, $13WX1.default),
        (0, $5yCDo.default)
    ],
    [$a861837a9717b6e8$var$typeNames.livePage]: [
        (0, $brDJd.default),
        (0, $deok5.default)
    ],
    [$a861837a9717b6e8$var$typeNames.blogpost]: [
        (0, $hxQwS.default),
        (0, $bueVT.default)
    ],
    [$a861837a9717b6e8$var$typeNames.whiteboard]: [
        (0, $b5erW.Whiteboard16Icon),
        (0, $6ilhH.Whiteboard24Icon)
    ],
    [$a861837a9717b6e8$var$typeNames.database]: [
        (0, $l6Uai.Database16Icon),
        (0, $zA80N.Database24Icon)
    ],
    [$a861837a9717b6e8$var$typeNames.embed]: [
        (0, $kYaDH.Embed16Icon),
        (0, $l5uVy.Embed24Icon)
    ],
    [$a861837a9717b6e8$var$typeNames.calendar]: [
        (0, $1dIkM.default),
        (0, $8XnT0.default)
    ],
    [$a861837a9717b6e8$var$typeNames.calendarView]: [
        (0, $1dIkM.default),
        (0, $8XnT0.default)
    ],
    //TODO: Remove the custom Icons once atlaskit adds the CommentIcons
    // https://ecosystem.atlassian.net/browse/AK-6057
    [$a861837a9717b6e8$var$typeNames.comment]: [
        (0, $hysuJ.Comment16Icon),
        (0, $gGVuu.Comment24Icon)
    ],
    [$a861837a9717b6e8$var$typeNames.question]: [
        (0, $l79Tc.default),
        (0, $5qgLK.default)
    ],
    [$a861837a9717b6e8$var$typeNames.space]: [
        (0, $9uooB.Space16Icon)
    ],
    [$a861837a9717b6e8$var$typeNames.smartLinkEmbed]: [
        (0, $c3Buv.SmartLinkEmbed16Icon),
        (0, $1XIce.SmartLinkEmbed24Icon)
    ],
    // the small folder icon is 20x20
    // once the next version of design system is released this icon can be imported
    // from platform, and all small icons will be this size
    [$a861837a9717b6e8$var$typeNames.folder]: [
        (0, $8vuWl.Folder20Icon),
        (0, $56LwR.Folder24Icon)
    ],
    [$a861837a9717b6e8$var$typeNames.import]: [
        (0, $aJZ9x.Import16Icon),
        (0, $aeG1X.Import24Icon)
    ]
};
const $a861837a9717b6e8$export$cba2ec8f585df2e0 = ({ label: label = '', primaryColor: primaryColor, size: // can override default icon color
size = 'medium', type: type = $a861837a9717b6e8$var$typeNames.page, subType: subType = '' })=>{
    let testId = `content-icon-${size}`;
    const getIcon = ()=>{
        let contentType = type ? type.toLowerCase() : '';
        // embed v1 and embed v2 pass in the same content type value but use different icons
        if (contentType === $a861837a9717b6e8$var$typeNames.embed) contentType = $a861837a9717b6e8$var$typeNames.smartLinkEmbed;
        //handle live pages
        if (subType && subType.toLowerCase() === 'live') contentType = $a861837a9717b6e8$var$typeNames.livePage;
        const icons = $a861837a9717b6e8$export$b14ad400b1d09e0f[contentType] || $a861837a9717b6e8$export$b14ad400b1d09e0f[$a861837a9717b6e8$var$typeNames.page];
        testId = $a861837a9717b6e8$export$b14ad400b1d09e0f[contentType] ? testId.concat(`-${contentType}`) : testId.concat(`-page`);
        let sizeIndex = $a861837a9717b6e8$export$c647cb0ee6e282fe.indexOf(size);
        sizeIndex = sizeIndex > 0 ? sizeIndex : 0;
        const IconComponent = icons[sizeIndex];
        return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(IconComponent, props);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(getIcon(), {
        size: size,
        label: label,
        primaryColor: primaryColor,
        testId: testId
    });
};

});
parcelRegister("1dIkM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d187e8c753963fcb$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a6da197bbcce0892f27de2b06510f3b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dQMPp = parcelRequire("dQMPp");

var $8DN9t = parcelRequire("8DN9t");

var $dh538 = parcelRequire("dh538");

var $eEVpS = parcelRequire("eEVpS");
/**
 * __16px `calendar` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $d187e8c753963fcb$var$Calendar16Icon = ({ label: label, testId: testId })=>{
    if ((0, $dh538.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dQMPp.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))),
        appearance: "redBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEVpS.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eEVpS.default), {
        label: label,
        testId: testId
    });
};
$d187e8c753963fcb$var$Calendar16Icon.displayName = 'Calendar16Icon';
var $d187e8c753963fcb$export$2e2bcd8739ae039 = $d187e8c753963fcb$var$Calendar16Icon;

});
parcelRegister("eEVpS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d12132ffb75c40bc$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7dd213aefc713f052644c932f145ae42>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5DTTe = parcelRequire("5DTTe");
const $d12132ffb75c40bc$var$Calendar16Icon = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $5DTTe.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M6 5H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zM2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m8 4v1h2V4a1 1 0 0 0-2 0M4 4v1h2V4a1 1 0 0 0-2 0m1 4h6v3H5z"/></svg>`,
        ...props,
        size: "small"
    });
$d12132ffb75c40bc$var$Calendar16Icon.displayName = 'Calendar16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d12132ffb75c40bc$export$2e2bcd8739ae039 = $d12132ffb75c40bc$var$Calendar16Icon;

});


parcelRegister("8XnT0", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba20ccc825fd56a9$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::03611d977353356cfe6a822232b999af>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dQMPp = parcelRequire("dQMPp");

var $8DN9t = parcelRequire("8DN9t");

var $dh538 = parcelRequire("dh538");

var $4Tvwq = parcelRequire("4Tvwq");
/**
 * __24px `calendar` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $ba20ccc825fd56a9$var$Calendar24Icon = ({ label: label, testId: testId })=>{
    if ((0, $dh538.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dQMPp.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8DN9t))),
        appearance: "redBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4Tvwq.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4Tvwq.default), {
        label: label,
        testId: testId
    });
};
$ba20ccc825fd56a9$var$Calendar24Icon.displayName = 'Calendar24Icon';
var $ba20ccc825fd56a9$export$2e2bcd8739ae039 = $ba20ccc825fd56a9$var$Calendar24Icon;

});
parcelRegister("4Tvwq", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5c0019fe46e51e4$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::03a498292f15351abd783b768eaf5bbf>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5DTTe = parcelRequire("5DTTe");
const $c5c0019fe46e51e4$var$Calendar24Icon = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $5DTTe.IconFacade), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M16 6H8V5a1 1 0 1 0-2 0v1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2V5a1 1 0 0 0-2 0zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 10v8h12v-8z"/></svg>`,
        ...props,
        size: "medium"
    });
$c5c0019fe46e51e4$var$Calendar24Icon.displayName = 'Calendar24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c5c0019fe46e51e4$export$2e2bcd8739ae039 = $c5c0019fe46e51e4$var$Calendar24Icon;

});


parcelRegister("l79Tc", function(module, exports) {

$parcel$export(module.exports, "default", () => $2528712af2809513$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9a6bc32655679a3a171f4a2e5e36fef5>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dQMPp = parcelRequire("dQMPp");

var $ci7Ox = parcelRequire("ci7Ox");

var $dh538 = parcelRequire("dh538");

var $h3vVu = parcelRequire("h3vVu");
/**
 * __16px `question` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $2528712af2809513$var$Question16Icon = ({ label: label, testId: testId })=>{
    if ((0, $dh538.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dQMPp.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))),
        appearance: "purpleBold",
        size: "16",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h3vVu.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $h3vVu.default), {
        label: label,
        testId: testId
    });
};
$2528712af2809513$var$Question16Icon.displayName = 'Question16Icon';
var $2528712af2809513$export$2e2bcd8739ae039 = $2528712af2809513$var$Question16Icon;

});
parcelRegister("h3vVu", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f9bfcefd2d3fd64$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::736d5f83cb238af68790810f5867434d>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5DTTe = parcelRequire("5DTTe");
const $5f9bfcefd2d3fd64$var$Question16Icon = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $5DTTe.IconFacade), {
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#6554c0" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m9.751 5.75a3.75 3.75 0 0 0-7.5 0 1 1 0 0 0 2 0 1.75 1.75 0 1 1 2.687 1.476l-1.48.957a1 1 0 0 0-.457.84V10a1 1 0 0 0 2 0v-.454l.873-.565c1.117-.65 1.877-1.846 1.877-3.231M8.001 12a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/></svg>`,
        ...props,
        size: "small"
    });
$5f9bfcefd2d3fd64$var$Question16Icon.displayName = 'Question16Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5f9bfcefd2d3fd64$export$2e2bcd8739ae039 = $5f9bfcefd2d3fd64$var$Question16Icon;

});


parcelRegister("5qgLK", function(module, exports) {

$parcel$export(module.exports, "default", () => $313a1109dece25f3$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f87b3b1facc5f78df512042b58732783>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $dQMPp = parcelRequire("dQMPp");

var $ci7Ox = parcelRequire("ci7Ox");

var $dh538 = parcelRequire("dh538");

var $2V5U2 = parcelRequire("2V5U2");
/**
 * __24px `question` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */ const $313a1109dece25f3$var$Question24Icon = ({ label: label, testId: testId })=>{
    if ((0, $dh538.fg)('icon-object-migration')) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dQMPp.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))),
        appearance: "purpleBold",
        size: "24",
        label: label,
        testId: testId,
        LEGACY_fallbackComponent: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2V5U2.default), {
            label: label,
            testId: testId
        })
    });
    else return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2V5U2.default), {
        label: label,
        testId: testId
    });
};
$313a1109dece25f3$var$Question24Icon.displayName = 'Question24Icon';
var $313a1109dece25f3$export$2e2bcd8739ae039 = $313a1109dece25f3$var$Question24Icon;

});
parcelRegister("2V5U2", function(module, exports) {

$parcel$export(module.exports, "default", () => $77b4592ff1fe9088$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2bae0e0e5693ec71d16bbeeccda2e35>>
 * @codegenCommand yarn build:icon-glyphs
 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $5DTTe = parcelRequire("5DTTe");
const $77b4592ff1fe9088$var$Question24Icon = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $5DTTe.IconFacade), {
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#6554c0" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0-2a7 7 0 1 1 0-14 7 7 0 0 1 0 14m3.238-8.88a3.12 3.12 0 0 0-6.238 0 1 1 0 1 0 2 0 1.119 1.119 0 0 1 2.238 0 1.1 1.1 0 0 1-.329.775l-1.499.994a1 1 0 0 0-.448.834v.022h-.002v.753a1 1 0 0 0 2 0v-.228l.717-.464a3.1 3.1 0 0 0 1.561-2.687m-3.285 4.882a.998.998 0 1 0 0 1.997.998.998 0 0 0 0-1.997"/></svg>`,
        ...props,
        size: "medium"
    });
$77b4592ff1fe9088$var$Question24Icon.displayName = 'Question24Icon';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$77b4592ff1fe9088$export$2e2bcd8739ae039 = $77b4592ff1fe9088$var$Question24Icon;

});


parcelRegister("hysuJ", function(module, exports) {

$parcel$export(module.exports, "Comment16Icon", () => $69a60ce401fab00e$export$91c492b3406980cd);

var $gwFzn = parcelRequire("gwFzn");

var $dQMPp = parcelRequire("dQMPp");

var $1yB28 = parcelRequire("1yB28");
const $69a60ce401fab00e$export$91c492b3406980cd = (props)=>{
    const label = props.label || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dQMPp.default), {
        key: "comment",
        label: label,
        appearance: "greenBold",
        shape: "square",
        size: "16",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
        testId: props.testId
    });
};

});

parcelRegister("gGVuu", function(module, exports) {

$parcel$export(module.exports, "Comment24Icon", () => $94942ad8062696a6$export$4991068bd7aa0d8f);

var $gwFzn = parcelRequire("gwFzn");

var $dQMPp = parcelRequire("dQMPp");

var $1yB28 = parcelRequire("1yB28");
const $94942ad8062696a6$export$4991068bd7aa0d8f = (props)=>{
    const label = props.label || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dQMPp.default), {
        key: "comment",
        label: label,
        appearance: "greenBold",
        shape: "square",
        size: "24",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
        testId: props.testId
    });
};

});

parcelRegister("b5erW", function(module, exports) {

$parcel$export(module.exports, "Whiteboard16Icon", () => $78ddc16686e264c3$export$3feee2bd05046f06);

var $gwFzn = parcelRequire("gwFzn");

var $dQMPp = parcelRequire("dQMPp");

var $ZDq1z = parcelRequire("ZDq1z");
const $78ddc16686e264c3$export$3feee2bd05046f06 = (props)=>{
    const label = props.label || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dQMPp.default), {
        key: "whiteboard",
        label: label,
        appearance: "tealBold",
        shape: "square",
        size: "16",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        testId: props.testId
    });
};

});

parcelRegister("6ilhH", function(module, exports) {

$parcel$export(module.exports, "Whiteboard24Icon", () => $358b2993473c16bd$export$c390d21aed730b04);

var $gwFzn = parcelRequire("gwFzn");

var $ZDq1z = parcelRequire("ZDq1z");

var $dQMPp = parcelRequire("dQMPp");
const $358b2993473c16bd$export$c390d21aed730b04 = (props)=>{
    const label = props.label || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dQMPp.default), {
        key: "whiteboard",
        label: label,
        appearance: "tealBold",
        shape: "square",
        size: "24",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        testId: props.testId
    });
};

});

parcelRegister("kYaDH", function(module, exports) {

$parcel$export(module.exports, "Embed16Icon", () => $7d7c13fcf2dc8ca1$export$1777e190ef1e8c7e);

var $gwFzn = parcelRequire("gwFzn");

var $dQMPp = parcelRequire("dQMPp");

var $1bY7o = parcelRequire("1bY7o");
const $7d7c13fcf2dc8ca1$export$1777e190ef1e8c7e = (props)=>{
    const label = props.label || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dQMPp.default), {
        key: "embed",
        label: label,
        appearance: "grayBold",
        shape: "square",
        size: "16",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
        testId: props.testId
    });
};

});

parcelRegister("l5uVy", function(module, exports) {

$parcel$export(module.exports, "Embed24Icon", () => $010aa1cb38368a61$export$2a3c0a6fcc3d13f7);

var $gwFzn = parcelRequire("gwFzn");

var $dQMPp = parcelRequire("dQMPp");

var $1bY7o = parcelRequire("1bY7o");
const $010aa1cb38368a61$export$2a3c0a6fcc3d13f7 = (props)=>{
    const label = props.label || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dQMPp.default), {
        key: "embed",
        label: label,
        appearance: "grayBold",
        shape: "square",
        size: "24",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
        testId: props.testId
    });
};

});

parcelRegister("zA80N", function(module, exports) {

$parcel$export(module.exports, "Database24Icon", () => $3231b2b808a58d84$export$87e082d1691e97d7);

var $gwFzn = parcelRequire("gwFzn");

var $dQMPp = parcelRequire("dQMPp");

var $2g1PW = parcelRequire("2g1PW");
const $3231b2b808a58d84$export$87e082d1691e97d7 = (props)=>{
    const label = props.label || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dQMPp.default), {
        key: "database",
        label: label,
        appearance: "purpleBold",
        shape: "square",
        size: "24",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2g1PW))),
        testId: props.testId
    });
};

});

parcelRegister("l6Uai", function(module, exports) {

$parcel$export(module.exports, "Database16Icon", () => $736b9d3dfbf57a75$export$edcbc8c5e08152a2);

var $gwFzn = parcelRequire("gwFzn");

var $dQMPp = parcelRequire("dQMPp");

var $6B0jU = parcelRequire("6B0jU");
const $736b9d3dfbf57a75$export$edcbc8c5e08152a2 = (props)=>{
    const label = props.label || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dQMPp.default), {
        key: "database",
        label: label,
        appearance: "purpleBold",
        shape: "square",
        size: "16",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
        testId: props.testId
    });
};

});

parcelRegister("9uooB", function(module, exports) {

$parcel$export(module.exports, "Space16Icon", () => $9225b29c304707ce$export$e3d323811b90e687);

var $gwFzn = parcelRequire("gwFzn");

var $dQMPp = parcelRequire("dQMPp");

var $g5gZt = parcelRequire("g5gZt");
const $9225b29c304707ce$export$e3d323811b90e687 = (props)=>{
    const label = props.label || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dQMPp.default), {
        key: "spaceIcon",
        label: label,
        appearance: "blue",
        shape: "square",
        size: "16",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))),
        testId: props.testId
    });
};

});

parcelRegister("c3Buv", function(module, exports) {

$parcel$export(module.exports, "SmartLinkEmbed16Icon", () => $94c1f7c488a00ca4$export$27580313d3229d13);

var $gwFzn = parcelRequire("gwFzn");

var $dQMPp = parcelRequire("dQMPp");

var $1bY7o = parcelRequire("1bY7o");
const $94c1f7c488a00ca4$export$27580313d3229d13 = (props)=>{
    const label = props.label || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dQMPp.default), {
        key: "smartLinkEmbed",
        label: label,
        appearance: "limeBold",
        shape: "square",
        size: "16",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
        testId: props.testId
    });
};

});

parcelRegister("1XIce", function(module, exports) {

$parcel$export(module.exports, "SmartLinkEmbed24Icon", () => $0bfb9a74c556c519$export$3c2e561a97cf528f);

var $gwFzn = parcelRequire("gwFzn");

var $dQMPp = parcelRequire("dQMPp");

var $1bY7o = parcelRequire("1bY7o");
const $0bfb9a74c556c519$export$3c2e561a97cf528f = (props)=>{
    const label = props.label || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dQMPp.default), {
        key: "smartLinkEmbed",
        label: label,
        appearance: "limeBold",
        shape: "square",
        size: "24",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
        testId: props.testId
    });
};

});

parcelRegister("8vuWl", function(module, exports) {

$parcel$export(module.exports, "Folder20Icon", () => $ebd8c2d6395d7c1b$export$4ec9cf0231518e70);

var $gwFzn = parcelRequire("gwFzn");

var $dQMPp = parcelRequire("dQMPp");

var $5tmwS = parcelRequire("5tmwS");
const $ebd8c2d6395d7c1b$export$4ec9cf0231518e70 = (props)=>{
    const label = props.label || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dQMPp.default), {
        key: "folder",
        label: label,
        appearance: "magentaBold",
        shape: "square",
        size: "16",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))),
        testId: props.testId
    });
};

});

parcelRegister("56LwR", function(module, exports) {

$parcel$export(module.exports, "Folder24Icon", () => $af8e1b13059a2e66$export$597e5478b58ebbac);

var $gwFzn = parcelRequire("gwFzn");

var $dQMPp = parcelRequire("dQMPp");

var $5tmwS = parcelRequire("5tmwS");
const $af8e1b13059a2e66$export$597e5478b58ebbac = (props)=>{
    const label = props.label || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dQMPp.default), {
        key: "folder",
        label: label,
        appearance: "magentaBold",
        shape: "square",
        size: "24",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5tmwS))),
        testId: props.testId
    });
};

});

parcelRegister("aJZ9x", function(module, exports) {

$parcel$export(module.exports, "Import16Icon", () => $665212012f6f10c2$export$ab2e577110439d4f);

var $gwFzn = parcelRequire("gwFzn");

var $hw7wB = parcelRequire("hw7wB");
const $665212012f6f10c2$export$ab2e577110439d4f = (props)=>{
    const primaryColor = props.primaryColor || "var(--ds-icon, #44546F)";
    const label = props.label || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hw7wB))), {
        label: label,
        color: primaryColor
    });
};

});

parcelRegister("aeG1X", function(module, exports) {

$parcel$export(module.exports, "Import24Icon", () => $386c33b21965393d$export$832de3f2b402688f);

var $gwFzn = parcelRequire("gwFzn");

var $hw7wB = parcelRequire("hw7wB");
const $386c33b21965393d$export$832de3f2b402688f = (props)=>{
    const primaryColor = props.primaryColor || "var(--ds-icon, #44546F)";
    const label = props.label || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hw7wB))), {
        label: label,
        color: primaryColor
    });
};

});



//# sourceMappingURL=EndOfPageRecommendation.f21c7089.js.map
